/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSignpostIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-signpost"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.68 21.48L10.68 18.5L6.7 18.5Q6.13 18.5 5.61 18.27Q5.1 18.05 4.72 17.63L3.1 15.78Q2.73 15.35 2.75 14.8Q2.77 14.25 3.2 13.9L4.78 12.5Q5.13 12.18 5.58 12.01Q6.03 11.85 6.53 11.85L10.68 11.85L10.68 9.85L4.53 9.85Q3.98 9.85 3.59 9.46Q3.2 9.07 3.2 8.53L3.2 4.53Q3.2 3.98 3.59 3.59Q3.98 3.2 4.53 3.2L10.68 3.2L10.68 2.52Q10.68 1.98 11.06 1.59Q11.45 1.2 12 1.2Q12.55 1.2 12.94 1.59Q13.32 1.98 13.32 2.52L13.32 3.2L17.38 3.2Q17.9 3.2 18.39 3.4Q18.88 3.6 19.25 3.98L20.88 5.6Q21.27 6 21.27 6.53Q21.27 7.05 20.88 7.45L19.25 9.07Q18.88 9.45 18.39 9.65Q17.9 9.85 17.38 9.85L13.32 9.85L13.32 11.85L19.48 11.85Q20.02 11.85 20.41 12.24Q20.8 12.63 20.8 13.18L20.8 17.18Q20.8 17.73 20.41 18.11Q20.02 18.5 19.48 18.5L13.32 18.5L13.32 21.48Q13.32 22.02 12.94 22.41Q12.55 22.8 12 22.8Q11.45 22.8 11.06 22.41Q10.68 22.02 10.68 21.48Z" fill={color} />
    </svg>
  );
}
